// components
import LoginForm from "../LoginForm/LoginForm";

// components
import Logo from "../../ui/Logo/Logo";

const FormContainer = () => {
  return (
    <>
      <Logo classNames="absolute left-10 top-10 lg:hidden " />
      <div className="text-right relative top-28 w-11/12 mx-auto md:w-1/2 lg:w-96 lg:absolute lg:right-44">
        <h1 className="mb-5">تسجيل الدخول</h1>
        <LoginForm />
      </div>
    </>
  );
};

export default FormContainer;
